import NodeModel from 'rise-ui/models/types/node.js';

import { attr } from '@ember-data/model';

export default class PageModel extends NodeModel {
  @attr('string') uuid;
  @attr('string') title;
  @attr('string') contentType;
  @attr image;
}
